var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonTooltip',{attrs:{"color":"primary","small":"","text":!_vm.bookmarkStore.isBookmarksDisplayed,"icon-name":`${
    _vm.bookmarkStore.isBookmarksDisplayed ? 'fa-list' : 'fa-list-alt'
  }`,"tooltip-text":_vm.bookmarkStore.isBookmarksDisplayed ? 'Hide Bookmarks' : 'Show Bookmarks',"tooltip-props":{ 'nudge-bottom': 8 },"button-text-right":"Bookmarks"},on:{"click":() =>
      (_vm.bookmarkStore.isBookmarksDisplayed =
        !_vm.bookmarkStore.isBookmarksDisplayed)}})
}
var staticRenderFns = []

export { render, staticRenderFns }